import { render, staticRenderFns } from "./IndexDoBrush.vue?vue&type=template&id=0976393d&scoped=true"
import script from "./IndexDoBrush.vue?vue&type=script&lang=js"
export * from "./IndexDoBrush.vue?vue&type=script&lang=js"
import style0 from "./IndexDoBrush.vue?vue&type=style&index=0&id=0976393d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976393d",
  null
  
)

export default component.exports